import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import theme from '@/theme';
import styled from '@emotion/styled';
import { InsightsSentiment } from '../utils/processInsightsUserTopics';

const MetricTileContainer = styled.div<{ size: 'small' | 'default' }>`
    display: flex;
    flex-direction: row;
    border-radius: 90px;
    overflow: hidden;

    font-size: ${({ size }) => (size === 'small' ? '12px' : '14px')};
`;

const MetricTileItem = styled.div<{ size: 'small' | 'default'; sentiment: 'positive' | 'negative' | 'neutral' }>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    padding: ${({ size }) => (size === 'small' ? '3px 6px' : '3px 6px')};
    min-width: ${({ size }) => (size === 'small' ? '46px' : '58px')};

    color: ${({ sentiment }) => {
        if (sentiment === 'positive') return theme.colors.success[750];
        if (sentiment === 'negative') return theme.colors.error[750];
        return theme.colors.secondary.main;
    }};

    background-color: ${({ sentiment }) => {
        if (sentiment === 'positive') return '#E7FFE7';
        if (sentiment === 'negative') return '#FEF2F2';
        return theme.colors.black[100];
    }};
`;

interface Props {
    metrics: {
        value: string;
        icon?: string;
        sentiment: InsightsSentiment;
    }[];
    size: 'small' | 'default';
}

export const MetricTile = ({ metrics, size }: Props) => {
    return (
        <MetricTileContainer size={size}>
            {metrics.map((metric, index) => (
                <MetricTileItem key={`${metric.value}-${index}`} size={size} sentiment={metric.sentiment}>
                    {!!metric.icon && <MaskedIcon src={metric.icon} size="16px" />}
                    {metric.value}
                </MetricTileItem>
            ))}
        </MetricTileContainer>
    );
};
